module.exports = __webpack_public_path__ + "img/banner-suzuki.459e13db.jpg";